import { FC } from 'react'
import { useHistory } from 'react-router-dom'
import clsx from 'clsx'
import {
  BooleanParam,
  NumberParam,
  useQueryParams,
  withDefault,
} from 'use-query-params'

import CustomRange from '../CustomRange'

import s from './Difficulty.module.css'

const rangeOptions = [
  {
    label: 'Very Hard',
    lowerLimit: 85,
    upperLimit: 100,
  },
  {
    label: 'Hard',
    lowerLimit: 70,
    upperLimit: 84,
  },
  {
    label: 'Difficult',
    lowerLimit: 50,
    upperLimit: 69,
  },
  {
    label: 'Possible',
    lowerLimit: 30,
    upperLimit: 49,
  },
  {
    label: 'Easy',
    lowerLimit: 15,
    upperLimit: 29,
  },
  {
    label: 'Very Easy',
    lowerLimit: 0,
    upperLimit: 14,
  },
]

type Props = {
  onChange: () => void
}

export const Difficulty: FC<Props> = ({ onChange }) => {
  const history = useHistory()
  const [queryParams, setQueryParams] = useQueryParams({
    'difficulty:lte': withDefault(NumberParam, null),
    'difficulty:gte': withDefault(NumberParam, null),
    'sug_difficulty:lte': withDefault(NumberParam, null),
    'sug_difficulty:gte': withDefault(NumberParam, null),
    page: withDefault(NumberParam, 1),
    content_ideas: withDefault(BooleanParam, false),
  })

  const isSuggestionsFilter =
    history.location.pathname === '/content-ideas' || queryParams.content_ideas

  const handleSubmit = (
    initialDifficulty: number | null,
    finalDifficulty: number | null
  ) => {
    if (isSuggestionsFilter) {
      setQueryParams({
        'sug_difficulty:lte': initialDifficulty,
        'sug_difficulty:gte': finalDifficulty,
        page: 1,
      })
    } else {
      setQueryParams({
        'difficulty:lte': initialDifficulty,
        'difficulty:gte': finalDifficulty,
        page: 1,
      })
    }

    onChange()
  }

  return (
    <div className={s.menu}>
      <div>
        {rangeOptions.map(range => {
          return (
            <button
              className={clsx(s.range, {
                [s.active]: isSuggestionsFilter
                  ? range.lowerLimit === queryParams['sug_difficulty:gte']
                  : range.lowerLimit === queryParams['difficulty:gte'],
              })}
              key={range.label}
              onClick={() => handleSubmit(range.upperLimit, range.lowerLimit)}
            >
              <span>{range.label}</span>

              {`${range.lowerLimit} - ${range.upperLimit}%`}
            </button>
          )
        })}
      </div>
      <CustomRange onSubmit={handleSubmit} />
    </div>
  )
}
